import React from 'react';

import {
	Box,
	Typography,
	Spacer,
	ComposedElement,
	RoundIcon,
	ComposableTypography,
	TypographyColorToken,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Call, Contacts, NavCloseO } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { ModalLocal } from '@components';
import { rem } from '@helpers';
import { modals } from '@modals';

import { useNeedHelpHelper } from './needHelp.helper';

export const NeedHelp: React.FC = () => {
	const { resources, numbers, hide } = useNeedHelpHelper();

	const secondaryLight: TypographyColorToken | undefined = 'secondary-light';

	const mainContent: JSX.Element = (
		<>
			<Box styles={{ display: 'flex', alignItems: 'center', flexGrow: 1, width: '100%' }}>
				<RoundIcon
					size="medium"
					mode="custom"
					icon={{
						source: Contacts,
						svgProps: {
							width: rem(40),
							height: rem(40),
							fill: '#D1005D',
						},
					}}
					container={{ styles: { border: '1px solid #EFF0F5' } }}
					color="transparent"
				/>
				<Spacer horizontal={rem(16)} />
				<Box styles={{ flexGrow: 1 }}>
					<Typography appearance="subtitle-100-04">{resources.title}</Typography>
				</Box>
				<Spacer horizontal={rem(4)} />
				<ComposedElement
					size="xxSmall"
					icon={{
						source: NavCloseO,
						svgProps: {
							fill: '#80838F',
						},
					}}
					onPress={hide}
				/>
			</Box>
			<Spacer vertical={rem(16)} />
			<Typography appearance="body-75-02">{resources.subtitle}</Typography>
			<Spacer vertical={rem(24)} />
			{numbers.map((numb) => {
				return (
					<Box styles={{ marginBottom: '24px', alignItems: 'center' }}>
						<ComposedElement
							size="xxSmall"
							icon={{
								source: Call,
								svgProps: {
									fill: '#D1005D',
								},
							}}
						/>
						<Spacer horizontal={rem(4)} />
						<ComposableTypography
							text={numb}
							baseProps={{
								appearance: 'body-75-03',
							}}
							tags={{
								highlight: {
									appearance: 'body-75-03',
									colorToken: 'secondary-light',
								},
							}}
						/>
					</Box>
				);
			})}
			<ComposableTypography
				text={resources.technicalHelp}
				baseProps={{
					appearance: 'body-75-02',
					colorToken: secondaryLight,
				}}
				tags={{
					highlight: {
						colorToken: secondaryLight,
					},
				}}
			/>
			<Spacer vertical={rem(8)} />
			<Typography appearance="body-75-02" colorToken={secondaryLight}>
				{resources.coastLabel}
			</Typography>
		</>
	);

	return (
		<ModalLocal
			name={modals.needHelp}
			contentCustomStyle={{
				padding: '32px 32px 32px 32px',
				width: rem(632),
			}}
			middleContent={{
				type: 'custom',
				content: mainContent,
			}}
			closeOnPressOutside={true}
			onCloseRequest={hide}
		/>
	);
};
